module.exports = __webpack_public_path__ + "static/media/academic_ancestry_screenshot.0dc2ac00.webp";